// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { createResponseObj } from '..'
import { vcBaseUrl } from '.'


type RevokeSessionResponse = (SuccessResponse & {
    status: string
}) | FailedResponse

export class RevokeSessionRequest extends Request {
    private constructor(init?: RequestInit) { super(`${vcBaseUrl}/session/revoke`, init) }
    static async init(body: {}, init?: RequestInit) {
        return new RevokeSessionRequest({
            ...init,
            method: 'DELETE',
            credentials: "include",
            body: JSON.stringify(body),
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<SuccessResponse & { status: string }> {
        const response = await fetch(this)
        const data = createResponseObj<RevokeSessionResponse>(await response.json())
        console.info("Revoke Session Results:", data)
    
        switch (data.status) {
            case 'successful': return data
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}